import { useParams, useNavigate } from 'react-router-dom';
import { useLang } from '../../hooks/useLang';
import { EXPERTS } from '../../mocks/experts';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { LangProvider } from '../../hooks/useLang';
import { useState } from 'react';

const EXPERT_DETAIL_LABELS: Record<string, Record<string, string>> = {
  notFound: { zh: '未找到该人物信息', en: 'Expert not found', fr: 'Expert non trouvé', es: 'Experto no encontrado', pt: 'Especialista não encontrado', ja: '人物が見つかりません', de: 'Experte nicht gefunden', ko: '전문가를 찾을 수 없습니다', ar: 'لم يتم العثور على الخبير', ru: 'Эксперт не найден' },
  backToList: { zh: '返回人物列表', en: 'Back to Experts', fr: 'Retour aux experts', es: 'Volver a expertos', pt: 'Voltar para especialistas', ja: '人物一覧に戻る', de: 'Zurück zu Experten', ko: '전문가 목록으로 돌아가기', ar: 'العودة إلى الخبراء', ru: 'Назад к экспертам' },
  home: { zh: '首页', en: 'Home', fr: 'Accueil', es: 'Inicio', pt: 'Início', ja: 'ホーム', de: 'Startseite', ko: '홈', ar: 'الرئيسية', ru: 'Главная' },
  profiles: { zh: '人物志', en: 'Profiles', fr: 'Profils', es: 'Perfiles', pt: 'Perfis', ja: '人物紹介', de: 'Profile', ko: '인물 소개', ar: 'الملفات الشخصية', ru: 'Профили' },
  birthYear: { zh: '年生', en: '', fr: '', es: '', pt: '', ja: '年生', de: '', ko: '년생', ar: '', ru: '' },
  educationAffiliation: { zh: '教育背景与所属机构', en: 'Education & Affiliation', fr: 'Formation & Affiliation', es: 'Educación y Afiliación', pt: 'Educação e Filiação', ja: '学歴と所属機関', de: 'Ausbildung & Zugehörigkeit', ko: '학력 및 소속 기관', ar: 'التعليم والانتماء', ru: 'Образование и принадлежность' },
  education: { zh: '教育背景', en: 'Education', fr: 'Formation', es: 'Educación', pt: 'Educação', ja: '学歴', de: 'Ausbildung', ko: '학력', ar: 'التعليم', ru: 'Образование' },
  affiliation: { zh: '所属机构', en: 'Affiliation', fr: 'Affiliation', es: 'Afiliación', pt: 'Filiação', ja: '所属機関', de: 'Zugehörigkeit', ko: '소속 기관', ar: 'الانتماء', ru: 'Принадлежность' },
  achievements: { zh: '核心荣誉与成就', en: 'Key Achievements', fr: 'Réalisations Clés', es: 'Logros Clave', pt: 'Conquistas Principais', ja: '主要な栄誉と実績', de: 'Wichtige Erfolge', ko: '주요 명예 및 성과', ar: 'الإنجازات الرئيسية', ru: 'Ключевые достижения' },
  rwaContribution: { zh: '区块链与RWA领域贡献', en: 'Blockchain & RWA Contributions', fr: 'Contributions Blockchain & RWA', es: 'Contribuciones Blockchain y RWA', pt: 'Contribuições Blockchain e RWA', ja: 'ブロックチェーンとRWA分野への貢献', de: 'Blockchain- und RWA-Beiträge', ko: '블록체인 및 RWA 분야 기여', ar: 'مساهمات البلوكتشين وRWA', ru: 'Вклад в блокчейн и RWA' },
  definingStory: { zh: '代表性故事', en: 'Defining Story', fr: 'Histoire Définissante', es: 'Historia Definitoria', pt: 'História Definidora', ja: '代表的な物語', de: 'Prägende Geschichte', ko: '대표적인 이야기', ar: 'القصة المحددة', ru: 'Определяющая история' },
  worksProjects: { zh: '代表著作与核心项目', en: 'Key Works & Projects', fr: 'Œuvres & Projets Clés', es: 'Obras y Proyectos Clave', pt: 'Obras e Projetos Principais', ja: '代表的著作と主要プロジェクト', de: 'Wichtige Werke & Projekte', ko: '대표 저작 및 핵심 프로젝트', ar: 'الأعمال والمشاريع الرئيسية', ru: 'Ключевые работы и проекты' },
  publishedWorks: { zh: '代表著作', en: 'Published Works', fr: 'Œuvres Publiées', es: 'Obras Publicadas', pt: 'Obras Publicadas', ja: '代表的著作', de: 'Veröffentlichte Werke', ko: '대표 저작', ar: 'الأعمال المنشورة', ru: 'Опубликованные работы' },
  keyProjects: { zh: '核心项目', en: 'Key Projects', fr: 'Projets Clés', es: 'Proyectos Clave', pt: 'Projetos Principais', ja: '主要プロジェクト', de: 'Wichtige Projekte', ko: '핵심 프로젝트', ar: 'المشاريع الرئيسية', ru: 'Ключевые проекты' },
  historicalParallel: { zh: '历史比拟 · 戏剧化解读', en: 'Historical Parallel · Dramatic Interpretation', fr: 'Parallèle Historique · Interprétation Dramatique', es: 'Paralelo Histórico · Interpretación Dramática', pt: 'Paralelo Histórico · Interpretação Dramática', ja: '歴史的比喩・劇的解釈', de: 'Historische Parallele · Dramatische Interpretation', ko: '역사적 비유 · 극적인 해석', ar: 'التوازي التاريخي · التفسير الدرامي', ru: 'Историческая параллель · Драматическая интерпретация' },
  from: { zh: '出自', en: 'From', fr: 'De', es: 'De', pt: 'De', ja: '出典', de: 'Aus', ko: '출처', ar: 'من', ru: 'Из' },
  englishNote: { zh: '英文版说明', en: 'English Note', fr: 'Note en Anglais', es: 'Nota en Inglés', pt: 'Nota em Inglês', ja: '英語版説明', de: 'Englische Anmerkung', ko: '영어판 설명', ar: 'ملاحظة بالإنجليزية', ru: 'Примечание на английском' },
  deepAnalysis: { zh: '深度解析', en: 'Deep Analysis', fr: 'Analyse Profonde', es: 'Análisis Profundo', pt: 'Análise Profunda', ja: '深い分析', de: 'Tiefe Analyse', ko: '심층 분석', ar: 'تحليل عميق', ru: 'Глубокий анализ' },
  quickInfo: { zh: '人物速览', en: 'Quick Info', fr: 'Info Rapide', es: 'Info Rápida', pt: 'Info Rápida', ja: '人物概要', de: 'Kurzinfo', ko: '인물 개요', ar: 'معلومات سريعة', ru: 'Краткая информация' },
  nationality: { zh: '国籍', en: 'Nationality', fr: 'Nationalité', es: 'Nacionalidad', pt: 'Nacionalidade', ja: '国籍', de: 'Nationalität', ko: '국적', ar: 'الجنسية', ru: 'Национальность' },
  birth: { zh: '出生年份', en: 'Birth Year', fr: 'Année de Naissance', es: 'Año de Nacimiento', pt: 'Ano de Nascimento', ja: '生年', de: 'Geburtsjahr', ko: '출생년도', ar: 'سنة الميلاد', ru: 'Год рождения' },
  year: { zh: '年', en: '', fr: '', es: '', pt: '', ja: '年', de: '', ko: '년', ar: '', ru: '' },
  sameCategory: { zh: '同类人物', en: 'Same Category', fr: 'Même Catégorie', es: 'Misma Categoría', pt: 'Mesma Categoria', ja: '同カテゴリー', de: 'Gleiche Kategorie', ko: '동일 카테고리', ar: 'نفس الفئة', ru: 'Та же категория' },
};

function ExpertDetailContent() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { lang } = useLang();
  const [riskModalOpen] = useState(false);
  const getLabel = (key: string) => EXPERT_DETAIL_LABELS[key]?.[lang] ?? EXPERT_DETAIL_LABELS[key]?.['en'] ?? key;

  const expert = EXPERTS.find((e) => e.id === id);

  if (!expert) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4 text-gray-200"><i className="ri-user-search-line"></i></div>
          <p className="text-gray-500 text-lg mb-6">{getLabel('notFound')}</p>
          <button onClick={() => navigate('/#experts')} className="px-6 py-3 bg-[#7C3AED] text-white rounded-xl font-bold text-sm cursor-pointer whitespace-nowrap">
            {getLabel('backToList')}
          </button>
        </div>
      </div>
    );
  }

  const novelName = (en: boolean) => {
    if (en) {
      return expert.historicalParallel.novel === 'sanguo'
        ? 'Romance of the Three Kingdoms (三国演义)'
        : 'Water Margin — Outlaws of the Marsh (水浒传)';
    }
    const novelNames: Record<string, Record<string, string>> = {
      sanguo: { zh: '《三国演义》', en: 'Romance of the Three Kingdoms', fr: 'Les Trois Royaumes', es: 'Romance de los Tres Reinos', pt: 'Romance dos Três Reinos', ja: '『三国志演義』', de: 'Die Drei Reiche', ko: '『삼국연의』', ar: 'رواية الممالك الثلاث', ru: 'Троецарствие' },
      shuihu: { zh: '《水浒传》', en: 'Water Margin', fr: 'Au Bord de l\'Eau', es: 'Al Borde del Agua', pt: 'Margem da Água', ja: '『水滸伝』', de: 'Die Räuber vom Liang-Schan-Moor', ko: '『수호전』', ar: 'على ضفاف الماء', ru: 'Речные заводи' },
    };
    return novelNames[expert.historicalParallel.novel]?.[lang] ?? novelNames[expert.historicalParallel.novel]?.['en'] ?? '';
  };

  const categoryPeers = EXPERTS.filter((e) => e.category === expert.category && e.id !== expert.id).slice(0, 3);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar onRiskModal={() => {}} />

      {/* Hero Banner */}
      <div className="relative pt-20 pb-14 overflow-hidden" style={{ background: `linear-gradient(135deg, ${expert.color}15, ${expert.color}05, #FAFAFA)` }}>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-[0.04]" style={{ background: `radial-gradient(circle, ${expert.color}, transparent)` }} />
        </div>
        <div className="relative max-w-[1100px] mx-auto px-4 lg:px-8">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-8 text-sm text-gray-400">
            <button onClick={() => navigate('/')} className="hover:text-gray-600 cursor-pointer whitespace-nowrap transition-colors">
              {getLabel('home')}
            </button>
            <i className="ri-arrow-right-s-line"></i>
            <button onClick={() => navigate('/#experts')} className="hover:text-gray-600 cursor-pointer whitespace-nowrap transition-colors">
              {getLabel('profiles')}
            </button>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-700 font-medium">{expert.name}</span>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Avatar */}
            <div className="w-24 h-24 lg:w-32 lg:h-32 flex items-center justify-center rounded-3xl shrink-0 text-white" style={{ background: `linear-gradient(135deg, ${expert.color}, ${expert.color}80)` }}>
              <i className={`${expert.icon} text-4xl lg:text-5xl`}></i>
            </div>

            {/* Info */}
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="text-xs px-2.5 py-1 rounded-full font-bold text-white" style={{ background: expert.color }}>
                  {expert.subCategory}
                </span>
                <span className="text-xs px-2.5 py-1 rounded-full font-medium bg-gray-100 text-gray-600">
                  {expert.nationality}
                </span>
                {expert.birthYear && (
                  <span className="text-xs px-2.5 py-1 rounded-full font-medium bg-gray-100 text-gray-600">
                    {expert.birthYear}{getLabel('birthYear') || getLabel('year')}
                  </span>
                )}
              </div>

              <h1 className="text-3xl lg:text-4xl font-black text-gray-900 mb-1">{expert.name}</h1>
              {expert.name !== expert.nameEn && (
                <p className="text-lg text-gray-400 font-medium mb-2">{expert.nameEn}</p>
              )}
              {expert.nickname && (
                <p className="text-base font-bold mb-3" style={{ color: expert.color }}>{expert.nickname}</p>
              )}

              <p className="text-sm text-gray-600 mb-3 font-medium">{expert.title}</p>
              <p className="text-sm text-gray-500 leading-relaxed max-w-2xl">{expert.headline}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1100px] mx-auto px-4 lg:px-8 pb-20">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left: Main Bio */}
          <div className="lg:col-span-2 space-y-8">

            {/* Education & Affiliation */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
              <h2 className="font-black text-gray-900 text-lg mb-5 flex items-center gap-2">
                <i className="ri-graduation-cap-line" style={{ color: expert.color }}></i>
                {getLabel('educationAffiliation')}
              </h2>
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="rounded-xl p-4" style={{ background: `${expert.color}08` }}>
                  <p className="text-xs font-bold text-gray-500 mb-1.5">{getLabel('education')}</p>
                  <p className="text-sm text-gray-700 leading-relaxed">{expert.education}</p>
                </div>
                <div className="rounded-xl p-4" style={{ background: `${expert.color}08` }}>
                  <p className="text-xs font-bold text-gray-500 mb-1.5">{getLabel('affiliation')}</p>
                  <p className="text-sm text-gray-700 font-semibold">{expert.affiliation}</p>
                  <p className="text-xs text-gray-400 mt-1">{expert.affiliationEn}</p>
                </div>
              </div>
            </div>

            {/* Key Achievements */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
              <h2 className="font-black text-gray-900 text-lg mb-5 flex items-center gap-2">
                <i className="ri-trophy-line" style={{ color: expert.color }}></i>
                {getLabel('achievements')}
              </h2>
              <div className="space-y-3">
                {expert.achievements.map((ach, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 mt-0.5 text-white text-xs font-black" style={{ background: expert.color }}>
                      {i + 1}
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed">{ach}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* RWA Contribution */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
              <h2 className="font-black text-gray-900 text-lg mb-4 flex items-center gap-2">
                <i className="ri-building-2-line" style={{ color: expert.color }}></i>
                {getLabel('rwaContribution')}
              </h2>
              <p className="text-sm text-gray-700 leading-relaxed">{expert.rwaContribution}</p>
            </div>

            {/* Story */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
              <h2 className="font-black text-gray-900 text-lg mb-4 flex items-center gap-2">
                <i className="ri-book-open-line" style={{ color: expert.color }}></i>
                {getLabel('definingStory')}
              </h2>
              <div className="relative">
                <div className="absolute left-0 top-0 bottom-0 w-0.5 rounded-full" style={{ background: expert.color }}></div>
                <p className="text-sm text-gray-700 leading-relaxed pl-5 italic">&ldquo;{expert.story}&rdquo;</p>
              </div>
            </div>

            {/* Books & Projects */}
            {(expert.books || expert.projects) && (
              <div className="bg-white rounded-2xl border border-gray-100 p-6">
                <h2 className="font-black text-gray-900 text-lg mb-5 flex items-center gap-2">
                  <i className="ri-archive-line" style={{ color: expert.color }}></i>
                  {getLabel('worksProjects')}
                </h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  {expert.books && expert.books.length > 0 && (
                    <div>
                      <p className="text-xs font-bold text-gray-500 mb-3 flex items-center gap-1.5">
                        <i className="ri-book-2-line"></i>{getLabel('publishedWorks')}
                      </p>
                      <div className="space-y-2">
                        {expert.books.map((book, i) => (
                          <div key={i} className="flex items-start gap-2">
                            <i className="ri-bookmark-line text-xs mt-0.5 shrink-0" style={{ color: expert.color }}></i>
                            <p className="text-sm text-gray-700">{book}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {expert.projects && expert.projects.length > 0 && (
                    <div>
                      <p className="text-xs font-bold text-gray-500 mb-3 flex items-center gap-1.5">
                        <i className="ri-rocket-line"></i>{getLabel('keyProjects')}
                      </p>
                      <div className="space-y-2">
                        {expert.projects.map((proj, i) => (
                          <div key={i} className="flex items-start gap-2">
                            <i className="ri-checkbox-circle-line text-xs mt-0.5 shrink-0" style={{ color: expert.color }}></i>
                            <p className="text-sm text-gray-700">{proj}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ===== HISTORICAL PARALLEL MODULE ===== */}
            <div className="rounded-2xl overflow-hidden" style={{ background: 'linear-gradient(135deg, #1a1535, #2d1f6e)', border: '1px solid rgba(167,139,250,0.25)' }}>
              {/* Header */}
              <div className="px-6 pt-6 pb-4" style={{ borderBottom: '1px solid rgba(167,139,250,0.15)' }}>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-xl" style={{ background: 'rgba(167,139,250,0.15)' }}>
                    <i className="ri-sword-line text-purple-300 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-purple-300 text-xs font-bold tracking-wider uppercase">{getLabel('historicalParallel')}</p>
                  </div>
                </div>
                <div className="mt-3">
                  <p className="text-white/50 text-xs mb-1">{getLabel('from')} {novelName(false)}</p>
                  <div className="flex items-center gap-3">
                    <span className="text-3xl font-black text-white">{expert.historicalParallel.character}</span>
                    <div className="flex-1 border-t border-white/10"></div>
                    <div className="text-right">
                      <p className="text-white/50 text-xs">{getLabel('englishNote')}</p>
                      <p className="text-purple-300 text-xs font-medium">{expert.historicalParallel.characterEn}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="px-6 py-5">
                {/* Intro comparison */}
                <div className="mb-5">
                  <p className="text-white/80 text-sm leading-relaxed">{expert.historicalParallel.intro}</p>
                </div>

                {/* Detailed comparison */}
                <div className="rounded-xl p-4 mb-5" style={{ background: 'rgba(167,139,250,0.08)', border: '1px solid rgba(167,139,250,0.12)' }}>
                  <div className="flex items-center gap-2 mb-3">
                    <i className="ri-sparkling-line text-purple-400 text-sm"></i>
                    <span className="text-purple-300 text-xs font-bold">{getLabel('deepAnalysis')}</span>
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed">{expert.historicalParallel.detail}</p>
                </div>

                {/* English note (if novel explanation needed) */}
                {expert.historicalParallel.introEn && (
                  <div className="rounded-xl p-4" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <div className="flex items-center gap-2 mb-2">
                      <i className="ri-global-line text-white/40 text-xs"></i>
                      <span className="text-white/40 text-xs font-bold">English Version</span>
                    </div>
                    <p className="text-white/50 text-xs leading-relaxed italic">{expert.historicalParallel.introEn}</p>
                    {expert.historicalParallel.novel === 'shuihu' && (
                      <div className="mt-3 pt-3 border-t border-white/10">
                        <p className="text-white/40 text-xs leading-relaxed">
                          <strong className="text-white/60">About Water Margin (水浒传):</strong> One of China&apos;s Four Great Classical Novels, depicting 108 outlawed heroes who gather at Liangshan Marsh to resist corrupt government and fight for justice. Each hero has a unique nickname and signature skill, making them beloved archetypes in Chinese culture.
                        </p>
                      </div>
                    )}
                    {expert.historicalParallel.novel === 'sanguo' && (
                      <div className="mt-3 pt-3 border-t border-white/10">
                        <p className="text-white/40 text-xs leading-relaxed">
                          <strong className="text-white/60">About Romance of the Three Kingdoms (三国演义):</strong> Another of China&apos;s Four Great Classical Novels, set in the turbulent Three Kingdoms period (220–280 AD). It depicts epic battles, strategic masterminds, and legendary warriors as the Han dynasty fractures into three rival kingdoms: Wei, Shu, and Wu.
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="space-y-6">
            {/* Quick Info */}
            <div className="bg-white rounded-2xl border border-gray-100 p-5 sticky top-24">
              <h3 className="font-black text-gray-900 text-sm mb-4">{getLabel('quickInfo')}</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <i className="ri-flag-line text-gray-400 text-sm mt-0.5 shrink-0"></i>
                  <div>
                    <p className="text-xs text-gray-400">{getLabel('nationality')}</p>
                    <p className="text-sm text-gray-700 font-medium">{expert.nationality}</p>
                  </div>
                </div>
                {expert.birthYear && (
                  <div className="flex items-start gap-2">
                    <i className="ri-calendar-line text-gray-400 text-sm mt-0.5 shrink-0"></i>
                    <div>
                      <p className="text-xs text-gray-400">{getLabel('birth')}</p>
                      <p className="text-sm text-gray-700 font-medium">{expert.birthYear}{getLabel('year')}</p>
                    </div>
                  </div>
                )}
                <div className="flex items-start gap-2">
                  <i className="ri-building-line text-gray-400 text-sm mt-0.5 shrink-0"></i>
                  <div>
                    <p className="text-xs text-gray-400">{getLabel('affiliation')}</p>
                    <p className="text-sm text-gray-700 font-medium">{expert.affiliation}</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-user-star-line text-gray-400 text-sm mt-0.5 shrink-0"></i>
                  <div>
                    <p className="text-xs text-gray-400">{getLabel('historicalParallel')}</p>
                    <p className="text-sm font-bold" style={{ color: expert.color }}>
                      {novelName(false)} · {expert.historicalParallel.character}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-5 pt-4 border-t border-gray-100">
                <button
                  onClick={() => navigate('/#experts')}
                  className="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-bold cursor-pointer whitespace-nowrap transition-all hover:opacity-90"
                  style={{ background: `${expert.color}15`, color: expert.color }}
                >
                  <i className="ri-arrow-left-line"></i>
                  {getLabel('backToList')}
                </button>
              </div>
            </div>

            {/* Same Category Experts */}
            {categoryPeers.length > 0 && (
              <div className="bg-white rounded-2xl border border-gray-100 p-5">
                <h3 className="font-black text-gray-900 text-sm mb-4">{getLabel('sameCategory')}</h3>
                <div className="space-y-3">
                  {categoryPeers.map((peer) => (
                    <div
                      key={peer.id}
                      className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors"
                      onClick={() => navigate(`/experts/${peer.id}`)}
                    >
                      <div className="w-9 h-9 flex items-center justify-center rounded-xl shrink-0 text-white text-sm" style={{ background: `${peer.color}90` }}>
                        <i className={peer.icon}></i>
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-sm font-bold text-gray-800 truncate">{peer.name}</p>
                        <p className="text-xs text-gray-400 truncate">{peer.affiliation}</p>
                      </div>
                      <i className="ri-arrow-right-s-line text-gray-300 shrink-0"></i>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default function ExpertDetailPage() {
  return (
    <LangProvider>
      <ExpertDetailContent />
    </LangProvider>
  );
}
